export const REQUEST_ACK_TIMEOUT_MS = 30_000

// Bound both response headers and body. Aborting cannot undo a server commit.
export const withRequestTimeout = async <T>(
  request: (signal: AbortSignal) => Promise<T>,
  timeoutMs = REQUEST_ACK_TIMEOUT_MS,
): Promise<T> => {
  const controller = new AbortController()
  let timer: ReturnType<typeof setTimeout> | undefined
  const deadline = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      controller.abort()
      reject(new Error('Request acknowledgement timed out'))
    }, timeoutMs)
  })
  try {
    return await Promise.race([request(controller.signal), deadline])
  } finally {
    clearTimeout(timer)
  }
}
